import { isSharjahOnlyAuthority, useAuthStore } from '../stores/auth.store';

export function usePermissions() {
  const permissions = useAuthStore((s) => s.permissions);
  const licensingAuthorities = useAuthStore((s) => s.licensingAuthorities);

  const can = (key: string): boolean => permissions.includes(key);

  const canViewField = (resource: string, field: string): boolean =>
    permissions.includes(`${resource}:view:${field}`);

  const canEditField = (resource: string, field: string): boolean =>
    permissions.includes(`${resource}:edit:${field}`);

  // When no authorities are assigned, all items pass (backward compat for existing users).
  const hasAuthority = (authority: string): boolean =>
    licensingAuthorities.length === 0 || licensingAuthorities.includes(authority);

  // True only for users scoped to Sharjah Municipality and not Kalba — used to switch
  // Sharjah-specific branding/data (dashboard KPIs, sidebar logo, login redirect) on for
  // that scope only. Mixed-authority or unrestricted users keep the default Kalba experience.
  const isSharjahOnly = isSharjahOnlyAuthority(licensingAuthorities);

  return { can, canViewField, canEditField, hasAuthority, isSharjahOnly };
}
